<template>
    <n-layout-header
        bordered
        style="
            height: 64px;
            display: flex;
            align-items: center;
            padding: 0 48px 0 30px;
            box-shadow: 0 10px 30px rgb(38 38 38 / 5%);
            z-index: 10;
            position: relative;
        "
    >
        <n-space justify="space-between" align="center" style="width: 100%">
            <n-space align="center" :size="[40, 0]">
                <router-link to="/">
                    <h3 style="color: black">PeerfectIT</h3>
                </router-link>
                <n-menu
                    mode="horizontal"
                    :options="menuOptions"
                    class="menuNav"
                />
            </n-space>
            <user-center></user-center>
        </n-space>
    </n-layout-header>
</template>

<script>
import { h } from "vue";

import { Apps } from "@vicons/ionicons5";
import { NAvatar, NText, NGrid, NGridItem, NButton } from "naive-ui";
import { RouterLink } from "vue-router";
import userCenter from "./userCenter.vue";

const name = "username";

function renderCustomHeader() {
    return h(NGrid, { cols: 2, xGap: 10 }, () => {
        return [
            h(NGridItem, null, () => {
                return [
                    h(
                        NButton,
                        {
                            circle: true,
                            size: "large",
                            style: "margin: 6px",
                        },
                        () => {
                            return "Ide";
                        },
                    ),
                ];
            }),
            h(NGridItem, null, () => {
                return [
                    h(
                        NButton,
                        {
                            circle: true,
                            size: "large",
                            style: "margin: 6px",
                        },
                        () => {
                            return "D";
                        },
                    ),
                ];
            }),
        ];
    });
}

function renderUserDropdown() {
    return h(
        "div",
        {
            style: "display: flex; align-items: center; padding: 8px 12px;",
        },
        [
            h(NAvatar, {
                round: true,
                style: "margin-right: 12px;",
                src: "https://07akioni.oss-cn-beijing.aliyuncs.com/demo1.JPG",
            }),
            h("div", null, [
                h("div", null, [
                    h(NText, { depth: 2 }, { default: () => "Employee" }),
                ]),
                h("div", { style: "font-size: 12px;" }, [
                    h(
                        NText,
                        { depth: 3 },
                        {
                            default: () =>
                                "Without a doubt, you are the brightest star in the office",
                        },
                    ),
                ]),
            ]),
        ],
    );
}

const menuOptions = [
    {
        label: "Products",
        key: "products",
        children: [
            {
                label: () =>
                    h(
                        RouterLink,
                        {
                            to: {
                                path: "/product/ide",
                            },
                        },
                        { default: () => "Online Editor" },
                    ),
                key: "ide",
            },
            {
                label: () =>
                    h(
                        RouterLink,
                        {
                            to: {
                                path: "/product/deploy",
                            },
                        },
                        { default: () => "Deploy" },
                    ),
                key: "deploy",
            },
        ],
    },
    {
        label: () =>
            h(
                RouterLink,
                {
                    to: {
                        path: "/pricing",
                    },
                },
                { default: () => "Pricing" },
            ),
        key: "pricing",
    },
    {
        label: () =>
            h(
                RouterLink,
                {
                    to: {
                        path: "/help",
                    },
                },
                { default: () => "Help" },
            ),
        key: "help",
    },
];
export default {
    name: "homeNav",
    data() {
        return {
            avatar,
            options: [
                {
                    label: "Account",
                    key: "profile",
                    type: "render",
                    render: renderCustomHeader,
                },
            ],
            userDropdownOptions: [
                {
                    label: "Account",
                    key: "profile",
                    type: "render",
                    render: renderUserDropdown,
                },
            ],
            menuOptions,
        };
    },
    components: {
        Apps,
        userCenter,
    },
};
</script>

<style scoped>
.menuNav {
    font-size: 18px;
    font-weight: bold;
}
</style>
